import { Injectable, OnDestroy } from '@angular/core';
import { IncludeScope, DeviceFilter } from 'DiscoveryEngine.TS/Core';
import { Owner, ViewerDeviceFilterDto } from 'UvExplorerServer.Dtos.TS/Viewer';


@Injectable()
export class DeviceFilterService implements OnDestroy {

	constructor() {
		return;
	}

	public getBuiltInDeviceFilters(): ViewerDeviceFilterDto[] {
		let result: ViewerDeviceFilterDto[] = [];

		let allDevicesDf = new DeviceFilter();
		allDevicesDf.VerifyGuid();
		allDevicesDf.Name = "<All Devices>";
		allDevicesDf.BaseIncludeScope = IncludeScope.AllDevices;
		let allDevicesVdf = new ViewerDeviceFilterDto(Owner.System, allDevicesDf);
		result.push(allDevicesVdf);

		let snmpDevicesDf = new DeviceFilter();
		snmpDevicesDf.VerifyGuid();
		snmpDevicesDf.Name = "<SNMP Devices>";
		snmpDevicesDf.BaseIncludeScope = IncludeScope.AllSnmpDevices;
		let snmpDevicesVdf = new ViewerDeviceFilterDto(Owner.System, snmpDevicesDf);
		result.push(snmpDevicesVdf);

		let networkDevicesDf = new DeviceFilter();
		networkDevicesDf.VerifyGuid();
		networkDevicesDf.Name = "<Network Devices>";
		networkDevicesDf.BaseIncludeScope = IncludeScope.AllNetworkDevices;
		let networkDevicesVdf = new ViewerDeviceFilterDto(Owner.System, networkDevicesDf);
		result.push(networkDevicesVdf);

		return result;
	}

	public ngOnDestroy(): void {
		return;
	}

}
